import type { ReactNode } from "react";

interface SectionProps {
  id: string;
  title: string;
  /** Optional short line shown under the section title. */
  subtitle?: string;
  children: ReactNode;
}

/**
 * Shared section scaffold: anchored container with a consistent heading block.
 * Reused by every content section so spacing and typography stay uniform.
 */
export function Section({
  id,
  title,
  subtitle,
  children,
}: SectionProps): JSX.Element {
  return (
    <section id={id} className="section" aria-labelledby={`${id}-heading`}>
      <div className="section__inner">
        <header className="section__head">
          <h2 id={`${id}-heading`} className="section__title">
            {title}
          </h2>
          {subtitle ? <p className="section__subtitle">{subtitle}</p> : null}
        </header>
        {children}
      </div>
    </section>
  );
}
